import { useEffect, useState, useRef } from "react";

function usePointerAndScroll(isMobile) {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0 });
  const rafRef = useRef(null);
  const scrollRafRef = useRef(null);

  useEffect(() => {
    // Mouse move with requestAnimationFrame throttling
    const handleMouseMove = (event) => {
      if (!isMobile) {
        if (rafRef.current) cancelAnimationFrame(rafRef.current);
        
        rafRef.current = requestAnimationFrame(() => {
          setMousePosition({ x: event.clientX, y: event.clientY });
        });
      }
    };

    // Scroll with requestAnimationFrame throttling
    const handleScroll = () => {
      if (scrollRafRef.current) cancelAnimationFrame(scrollRafRef.current);
      
      scrollRafRef.current = requestAnimationFrame(() => {
        setScrollPosition({ x: window.scrollX, y: window.scrollY });
      });
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("scroll", handleScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      if (scrollRafRef.current) cancelAnimationFrame(scrollRafRef.current);
    };
  }, [isMobile]);

  return { mousePosition, scrollPosition };
}

export default usePointerAndScroll;
